import { Checkbox } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function SelectAllTasks({ ...props }) {
    const { allTasks = [], selectedTasks = {}, setSelectedTasks } = useBoundContext()
    const numSelected = allTasks.filter(({ id }) => selectedTasks[id]).length
    const allChecked = allTasks.length > 0 && numSelected === allTasks.length

    return (
        <Checkbox
            indeterminate={numSelected > 0 && !allChecked}
            checked={allChecked}
            onChange={() =>
                setSelectedTasks(allChecked ? {} : Object.fromEntries(allTasks.map((task) => [task.id, [true, task]])))
            }
            {...props}
        />
    )
}
